import { createContext, useContext } from 'react'
import { type ClickToTextPageStore } from 'pages/clickToText'

export const ClickToTextPageContext = createContext<ClickToTextPageStore | null>(null)

export const useClickToTextPageContext = () => {
  const context = useContext(ClickToTextPageContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ClickToTextPageProvider')

  return context
}
